interface BrowserCheckoutLogEvent {
  source: string;
  stage: string;
  status?: string;
  checkoutId?: string | null;
  paymentSessionId?: string | null;
  orderId?: string | null;
  requestId?: string | null;
  publicTokenHash?: string | null;
  metadata?: Record<string, unknown> | null;
  error?: {
    code?: string;
    message?: string;
    details?: Record<string, unknown> | null;
  } | null;
  occurredAt?: string;
}

export async function logCheckoutEvent(event: BrowserCheckoutLogEvent) {
  try {
    await fetch('/.netlify/functions/log-checkout-event', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(event),
    });
  } catch (error) {
    console.error('Checkout event logging failed', error);
  }
}
